import { z } from "zod";

import moment from "moment";

import { Command } from "../../types";

export const resetSkippedIncomeTaxSchema = z.object({
  command: z.literal(Command.ResetSkippedIncomeTax),
  date: z.custom<moment.Moment>((value) => moment.isMoment(value), {
    message: "Please select a date",
  }),
});

export type ResetSkippedIncomeTaxFormValues = z.infer<
  typeof resetSkippedIncomeTaxSchema
>;
